/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} P1portal_Sidebar_Close_MenuInputs */



/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {P1portal_Sidebar_Close_MenuInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const p1portal_sidebar_close_menu = /** @type {((inputs?: P1portal_Sidebar_Close_MenuInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<P1portal_Sidebar_Close_MenuInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Close menu")
});